import React, { Component } from 'react';
import { Drawer, Checkbox, TextField, Radio, RadioGroup } from '@cimpress/react-components';

export default class DrawerDemo extends Component {
  state = { open: false, autoResize: true, size: 0.3, position: 'right' };

  closeDrawer = () => {
    this.setState({ open: false });
  };

  openDrawer = () => {
    this.setState({ open: true });
  };

  toggleAutoResize = () => {
    this.setState(prevState => {
      const autoResize = !prevState.autoResize;
      return { autoResize, size: autoResize ? 0.3 : 400 };
    });
  };

  onSizeChange = e => this.setState({ size: e.target.value });

  onPositionChange = (e, value) => this.setState({ position: value });

  render() {
    return (
      <div>
        <Checkbox label="Auto-resize" checked={this.state.autoResize} onChange={this.toggleAutoResize} />
        <h5>Drawer Position</h5>
        <RadioGroup onChange={this.onPositionChange} defaultSelected="right" name="radioTest">
          <Radio label="left" value="left" />
          <Radio label="right" value="right" />
          <Radio label="top" value="top" />
          <Radio label="bottom" value="bottom" />
        </RadioGroup>
        <TextField label="size" value={this.state.size} onChange={this.onSizeChange} variant="number" />
        <button className="btn btn-default" onClick={this.openDrawer}>
          Open drawer
        </button>
        <Drawer
          position={this.state.position}
          autoResize={this.state.autoResize}
          size={this.state.size}
          show={this.state.open}
          onRequestHide={this.closeDrawer}
          header="The drawer header"
          closeOnClickOutside={true}
          footer={
            <div>
              <button className="btn btn-default" onClick={this.closeDrawer}>
                Close drawer
              </button>
              <button className="btn btn-primary">Some other button</button>
            </div>
          }
        >
          <h1>
            Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock
            Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock
            Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock
            Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock
            Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock
            Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock
            Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock
            Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock Dock
            Dock Dock Dock Dock Dock Goose
          </h1>
        </Drawer>
      </div>
    );
  }
}
